import type React from 'react'
import Image from 'next/image'
import { PageTitle } from '@stone-payments/jade'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { APP_ENV } from 'shared/envs'

import { type KycStatusOnboardingProps } from '../kyc-onboarding.component'

import { KycStatusContainer } from './kyc-status-container'

import styles from './styles.module.css'

export const KycStatusOnboarding = ({ actionButton }: KycStatusOnboardingProps): React.JSX.Element => {
  const imageQrCode = APP_ENV() !== 'prod' ? '/onboarding/qr-code-image-sdb.png' : '/onboarding/qr-code-image-prd.png'
  return (
    <KycStatusContainer actionButton={actionButton}>
      <PageTitle title="Ative sua conta pelo aplicativo da Stone" />
      <div className={`${styles['center-container']} ${styles['color-text']}`}>
        <Image src="/onboarding/onboarding-ui-rg.svg" width={165} height={133} alt="Onboarding KYC" />
        <div className={`${styles['text-container']} ${styles['text-size']}`}>
          <ul>
            <li>
              1. Abra o app e toque em <strong>Entrar</strong>
            </li>
            <li>
              2. Informe seus <strong>dados de acesso</strong> para entrar
            </li>
            <li>
              3. <strong>Ative a conta</strong> e aguarde o prazo de análise
            </li>
          </ul>
          <p>
            Depois que a análise for aprovada, você vai conseguir acessar a conta pelo <strong>app</strong> e pelo{' '}
            <strong>computador</strong>.
          </p>
        </div>
      </div>
      <div className={styles['info-text']}>
        <p className={`${styles['color-text']} ${styles['text-size']}`}>
          Se preferir, aponte a câmera do seu celular ou tablet para o QR Code para abrir o app. Caso não tenha o app, o
          QR Code vai abrir a loja de aplicativos pra você baixar.
        </p>
        <Image src={imageQrCode} width={65} height={66} alt="Imagem de um QR Code" />
      </div>
    </KycStatusContainer>
  )
}
